app.controller('eWaybillNumberingMasterCtrl', function ($scope, urlServices, toaster, modalService, modalFactory) {
    var apiBase = 'api/e-waybill-numbering-masters';

    function createNumberingForm() {
        return {
            id: 0,
            marketingCode: '',
            totalCustomer: 0,
            prefix: '',
            description: '',
            stageOneDigits: 4,
            stageTwoAlphaLength: 1,
            stageTwoDigits: 3,
            stageThreeAlphaLength: 2,
            stageThreeDigits: 2,
            isActive: true
        };
    }

    function normalizeTextValue(value) {
        if (value === undefined || value === null) {
            return '';
        }

        return String(value).trim();
    }

    function normalizePrefixValue(value) {
        return normalizeTextValue(value).toUpperCase().replace(/\s+/g, '').slice(0, 5);
    }

    function normalizeNumberValue(value, fallbackValue) {
        var parsed = parseInt(value, 10);

        if (isNaN(parsed)) {
            return fallbackValue;
        }

        return parsed;
    }

    function buildErrorMessage(err, fallbackMessage) {
        if (!err) {
            return fallbackMessage;
        }
        if (err.err) {
            return err.err;
        }
        if (err.message) {
            return err.message;
        }

        return err;
    }

    function zeroPad(value, size) {
        var stringValue = String(Math.max(normalizeNumberValue(value, 0), 0));

        while (stringValue.length < size) {
            stringValue = '0' + stringValue;
        }

        return stringValue;
    }

    function buildAlphaPrefix(length) {
        return new Array(Math.max(normalizeNumberValue(length, 0), 0) + 1).join('A');
    }

    function normalizeRows(result) {
        return (result || []).map(function (row) {
            row.isActive = row.isActive !== false;
            return row;
        });
    }

    function resetNumberingForm() {
        $scope.numberingForm = createNumberingForm();
    }

    function applySelectedMarketingCode(item) {
        var selectedItem = item || {};

        $scope.numberingForm.marketingCode = normalizeTextValue(selectedItem.MarketingCode || selectedItem.marketing_code).toUpperCase();
        $scope.numberingForm.totalCustomer = Number(selectedItem.TotalCustomer || selectedItem.total_customer || 0);
        $scope.numberingForm.prefix = normalizePrefixValue(selectedItem.DefaultPrefix || selectedItem.defaultPrefix || selectedItem.prefix);
        if (!$scope.numberingForm.description) {
            $scope.numberingForm.description = $scope.numberingForm.marketingCode;
        }

        if ($scope.numberingForm.marketingCode) {
            return resolveMarketingCodePrefix($scope.numberingForm.marketingCode);
        }

        return null;
    }

    $scope.numberingRows = [];
    $scope.numberingLoading = false;
    $scope.numberingSaving = false;
    $scope.numberingResolvingMarketingCode = false;
    $scope.numberingFilter = '';
    $scope.numberingForm = createNumberingForm();

    function applyResolvedMarketingCode(result) {
        var resolved = result || {};

        $scope.numberingForm.marketingCode = resolved.marketingCode || '';
        $scope.numberingForm.totalCustomer = Number(resolved.totalCustomer || 0);
        $scope.numberingForm.prefix = normalizePrefixValue(resolved.prefix || '');
        if (!$scope.numberingForm.description) {
            $scope.numberingForm.description = resolved.marketingCode || '';
        }
    }

    function resolveMarketingCodePrefix(marketingCode) {
        var normalizedMarketingCode = normalizeTextValue(marketingCode).toUpperCase();

        $scope.numberingForm.marketingCode = normalizedMarketingCode;
        if (!normalizedMarketingCode) {
            $scope.numberingForm.totalCustomer = 0;
            return null;
        }

        $scope.numberingResolvingMarketingCode = true;
        return urlServices.ambilData(apiBase + '/marketing-code/' + encodeURIComponent(normalizedMarketingCode), {}, function (err, result) {
            $scope.numberingResolvingMarketingCode = false;
            if (err) {
                $scope.numberingForm.totalCustomer = 0;
                return toaster.pop('error', 'Master Management', buildErrorMessage(err, 'Gagal mengambil data marketing code'));
            }

            applyResolvedMarketingCode(result);
        });
    }

    $scope.getFormPreview = function () {
        var prefix = normalizeTextValue($scope.numberingForm.prefix).toUpperCase() || 'X';
        var sequenceYear = moment().format('YY');
        var previews = [prefix + sequenceYear + zeroPad(1, normalizeNumberValue($scope.numberingForm.stageOneDigits, 4))];

        if (normalizeNumberValue($scope.numberingForm.stageTwoAlphaLength, 0) > 0 && normalizeNumberValue($scope.numberingForm.stageTwoDigits, 0) > 0) {
            previews.push(prefix + sequenceYear + buildAlphaPrefix($scope.numberingForm.stageTwoAlphaLength) + zeroPad(1, normalizeNumberValue($scope.numberingForm.stageTwoDigits, 3)));
        }
        if (normalizeNumberValue($scope.numberingForm.stageThreeAlphaLength, 0) > 0 && normalizeNumberValue($scope.numberingForm.stageThreeDigits, 0) > 0) {
            previews.push(prefix + sequenceYear + buildAlphaPrefix($scope.numberingForm.stageThreeAlphaLength) + zeroPad(1, normalizeNumberValue($scope.numberingForm.stageThreeDigits, 2)));
        }

        return previews.join(' -> ');
    };

    $scope.loadNumberingMasters = function () {
        $scope.numberingLoading = true;
        return urlServices.ambilData(apiBase + '?include_inactive=1', {}, function (err, result) {
            $scope.numberingLoading = false;
            if (err) {
                return toaster.pop('error', 'Master Management', buildErrorMessage(err, 'Gagal memuat master penomoran e-waybill'));
            }

            $scope.numberingRows = normalizeRows(result);
        });
    };

    $scope.editNumberingMaster = function (row) {
        $scope.numberingForm = {
            id: row.id || 0,
            marketingCode: row.marketingCode || '',
            totalCustomer: row.totalCustomer || 0,
            prefix: row.prefix || '',
            description: row.description || '',
            stageOneDigits: row.stageOneDigits || 4,
            stageTwoAlphaLength: row.stageTwoAlphaLength || 0,
            stageTwoDigits: row.stageTwoDigits || 0,
            stageThreeAlphaLength: row.stageThreeAlphaLength || 0,
            stageThreeDigits: row.stageThreeDigits || 0,
            isActive: row.isActive !== false
        };
    };

    $scope.cancelNumberingMaster = function () {
        resetNumberingForm();
    };

    $scope.openMarketingCodeLookup = function () {
        return modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
            functionName: 'marketingCodeList',
            params: {}
        });
    };

    $scope.resolveSelectedMarketingCode = function () {
        return resolveMarketingCodePrefix($scope.numberingForm.marketingCode);
    };

    $scope.clearSelectedMarketingCode = function () {
        $scope.numberingForm.marketingCode = '';
        $scope.numberingForm.totalCustomer = 0;
        $scope.numberingForm.prefix = '';
    };

    $scope.saveNumberingMaster = function () {
        var payload = {
            id: $scope.numberingForm.id || 0,
            marketingCode: normalizeTextValue($scope.numberingForm.marketingCode).toUpperCase(),
            prefix: normalizePrefixValue($scope.numberingForm.prefix),
            description: normalizeTextValue($scope.numberingForm.description),
            stageOneDigits: normalizeNumberValue($scope.numberingForm.stageOneDigits, 4),
            stageTwoAlphaLength: normalizeNumberValue($scope.numberingForm.stageTwoAlphaLength, 1),
            stageTwoDigits: normalizeNumberValue($scope.numberingForm.stageTwoDigits, 3),
            stageThreeAlphaLength: normalizeNumberValue($scope.numberingForm.stageThreeAlphaLength, 2),
            stageThreeDigits: normalizeNumberValue($scope.numberingForm.stageThreeDigits, 2),
            isActive: $scope.numberingForm.isActive ? 1 : 0
        };
        var requestMethod = payload.id ? urlServices.updateData : urlServices.simpanData;

        if (!payload.marketingCode) {
            return toaster.pop('warning', 'Master Management', 'Marketing code wajib dipilih');
        }
        if (!payload.prefix) {
            return toaster.pop('warning', 'Master Management', 'Prefix belum diatur di subtab Prefix Marketing Code');
        }
        if ((payload.stageTwoAlphaLength > 0 && payload.stageTwoDigits < 1) || (payload.stageTwoAlphaLength < 1 && payload.stageTwoDigits > 0)) {
            return toaster.pop('warning', 'Master Management', 'Tahap 2 harus mengisi huruf dan digit sekaligus');
        }
        if ((payload.stageThreeAlphaLength > 0 && payload.stageThreeDigits < 1) || (payload.stageThreeAlphaLength < 1 && payload.stageThreeDigits > 0)) {
            return toaster.pop('warning', 'Master Management', 'Tahap 3 harus mengisi huruf dan digit sekaligus');
        }

        $scope.numberingSaving = true;
        return requestMethod(apiBase, payload, function (err, result) {
            $scope.numberingSaving = false;
            if (err) {
                return toaster.pop('error', 'Master Management', buildErrorMessage(err, 'Gagal menyimpan master penomoran e-waybill'));
            }

            $scope.numberingRows = normalizeRows(result && result.items ? result.items : $scope.numberingRows);
            resetNumberingForm();
            toaster.pop('success', 'Master Management', 'Master penomoran e-waybill berhasil disimpan');
            if (!(result && result.items)) {
                $scope.loadNumberingMasters();
            }
        });
    };

    $scope.deleteNumberingMaster = function (row) {
        modalService.showModal({}, {
            closeButtonText: 'No',
            actionButtonText: 'Yes',
            headerText: 'Hapus Master Penomoran',
            bodyText: 'Hapus master penomoran marketing code ' + (row.marketingCode || '-') + '?'
        }).then(function (confirmed) {
            if (!confirmed) {
                return;
            }

            return urlServices.hapusData(apiBase + '/' + encodeURIComponent(row.id), {}, function (err, result) {
                if (err) {
                    return toaster.pop('error', 'Master Management', buildErrorMessage(err, 'Gagal menghapus master penomoran e-waybill'));
                }

                if (Number($scope.numberingForm.id || 0) === Number(row.id || 0)) {
                    resetNumberingForm();
                }
                $scope.numberingRows = normalizeRows(result && result.items ? result.items : $scope.numberingRows);
                toaster.pop('success', 'Master Management', 'Master penomoran e-waybill berhasil dihapus');
                if (!(result && result.items)) {
                    $scope.loadNumberingMasters();
                }
            });
        });
    };

    $scope.$on('pilih-marketing-code', function (event, args) {
        applySelectedMarketingCode(args);
        return true;
    });

    resetNumberingForm();
    $scope.loadNumberingMasters();
});